  <template>
  <div id="wrapper">
    <!-- Sidebar -->
    <SideNav />
    <!-- Content Wrapper -->
    <div id="content-wrapper" class="d-flex flex-column">
      <!-- Main Content -->
      <div id="content">
        <!-- Topbar -->
        <nav class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
          <!-- Sidebar Toggle (Topbar) -->
          <button id="sidebarToggleTop" class="btn d-md-none rounded-circle mr-3">
            <i class="text-danger fa fa-bars"></i>
          </button>
         <ul class="navbar-nav ml-auto">
            <div class="topbar-divider d-none d-sm-block"></div>

            <!-- Nav Item - User Information -->
            <li class="nav-item dropdown no-arrow">
              <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                 Welcome!, {{dashboard.key === 'entity_user' ? currentUser.organisation.name : currentUser.name}}
                </span>
                <img class="img-profile rounded-circle" src="https://source.unsplash.com/QAB-WJcbgJk/60x60">
              </a>
              <!-- Dropdown - User Information -->
              <div class="dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="userDropdown">
                <!-- <a class="dropdown-item" href="#">
                  <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
                  Profile
                </a> -->
               
                <div class="dropdown-divider"></div>
                <a @click.prevent="logout" class="dropdown-item" href="#" data-toggle="modal" data-target="#logoutModal">
                  <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                  Logout
                </a>
              </div>
            </li>

          </ul>

        </nav>
        <!-- End of Topbar -->

        <!-- Begin Page Content -->
        <div class="container-fluid">
          <router-view />
        </div>
        <!-- /.container-fluid -->
      </div>
      <!-- End of Main Content -->
      <!-- Footer -->
      <button @click="topFunction" id="myBtn" title="Go to top"><i class="fas fa-arrow-up"></i></button>
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <p>Copyright &copy; TribeId</p>
              <p>In association with the <span style="color:black; font-weight:bolder"> African Union Open Corridors Initiative</span> </p>
              <p>In partnership with the <span style="color:black; font-weight:bolder">AFCFT Secretariat </span></p>
            </div>
          </div>
      </footer>
      <!-- End of Footer -->
    </div>
    <!-- End of Content Wrapper -->
    <!-- 
      Start modal component
     -->  
    <!-- <a class="scroll-to-top rounded" href="#wrapper">
     <i class="fas fa-angle-up"></i>
  </a> -->
  </div>
  <!-- End of Page Wrapper -->
</template>

<script>
import SideNav from './SideNav'
import { mapGetters } from 'vuex'
export default {
  name:'adminDashboard',
  components: {
    SideNav:SideNav
  },
  methods: {
    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    logout(e) {
      this.$router.replace('/admin/login')
        .then( ()=> {
          this.$store.dispatch('logout')
        })
    }
  },
  computed: { ...mapGetters(["currentUser","dashboard"]) },
  mounted() {
    var mybutton = document.getElementById("myBtn");
     function scrollFunction() {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
      } else {
        mybutton.style.display = "none";
      }
    }
    window.onscroll = function() {scrollFunction()};
  },
  created(){
  }
}
</script>
 
<style scoped>
  #accordionSidebar{
    background-color: #ba2428;
  }
  #myBtn {
  display: none;
  position: fixed;
  bottom: 20px;
  right: 30px;
  z-index: 99;
  font-size: 18px;
  border: none;
  outline: none;
  background-color: red;
  color: white;
  cursor: pointer;
  padding: 15px;
  border-radius: 4px;
}

#myBtn:hover {
  background-color: #555;
}
</style>